<template>
  <div class="page approval-page">
    <div class="approval-header clearfix">
      <div class="head-portrait">
        <img
          :src="
            loginAvatar == true
              ? '../assets/image/user-avatar.png'
              : loginAvatar
          "
          alt=""
        />
      </div>
      <div class="head-title">二级市场佣金分配</div>
      <div
        class="approval-status"
        :class="
          flowsStat == 100
            ? 'approval-ing'
            : flowsStat == 200
            ? 'approval-pass'
            : flowsStat == 500
            ? 'approval-refuse'
            : ''
        "
      >
        {{
          flowsStat == 100
            ? "审批中"
            : flowsStat == 200
            ? "已通过"
            : flowsStat == 500
            ? "已驳回"
            : ""
        }}
      </div>
    </div>
    <div class="approval-body">
        <div class="approval-part">
            <div class="approval-item-title">申请详情</div>
            <div class="approval-item clearfix">
                <div class="key">分佣比例类型</div>
                <div class="value">
                    {{ applicationDetails.allocationTable.commissionRateType }}
                </div>
            </div>
            <div class="approval-item clearfix">
                <div class="key">项目名称</div>
                <div class="value">
                    {{ applicationDetails.allocationTable.projectName }}
                </div>
            </div>
            <div class="approval-item clearfix">
                <div class="key">开发商名称</div>
                <div class="value">
                    {{ applicationDetails.allocationTable.developersName }}
                </div>
            </div>
            <div class="approval-item clearfix">
                <div class="key">盘源类型</div>
                <div class="value">
                    {{ applicationDetails.allocationTable.buildType }}
                </div>
            </div>
            <div class="approval-item clearfix">
                <div class="key">成交编号</div>
                <div class="value">
                    {{ applicationDetails.allocationTable.contractNo }}
                </div>
            </div>
            <div v-show="monisShow" class="approval-item clearfix">
                <div class="key">对外分佣(元)</div>
                <div class="value">
                    {{ applicationDetails.allocationTable.externalCommission }}
                </div>
            </div>
            <div class="approval-item clearfix">
                <div class="key">申请变更日期</div>
                <div class="value">
                    {{ applicationDetails.allocationTable.applyChangeDate }}
                </div>
            </div>
            <div v-show="monisShow" class="approval-item clearfix">
                <div class="key">转介费(元)</div>
                <div class="value">
                    {{ applicationDetails.allocationTable.referralFee }}
                </div>
            </div>
            <div class="approval-item clearfix">
                <div class="key">类别</div>
                <div class="value">
                    {{ applicationDetails.allocationTable.projectType }}
                </div>
            </div>
            <div class="approval-item clearfix">
                <div class="key">是否在以后销售佣金中抵扣</div>
                <div class="value">
                    {{
              applicationDetails.allocationTable.laterCommissionDeduction === true ? "是" :
                  applicationDetails.allocationTable.laterCommissionDeduction !== null ? "否" : ""
                    }}
                </div>
            </div>
            <div class="approval-item clearfix">
                <div class="key">代理类型</div>
                <div class="value">
                    {{ applicationDetails.allocationTable.agencyType }}
                </div>
            </div>
            <div class="approval-item clearfix">
                <div class="key">品牌顾问策划项目</div>
                <div class="value">
                    {{
              applicationDetails.allocationTable
                .brandConsultantPlanningProject == true ? "是" :
                  applicationDetails.allocationTable.brandConsultantPlanningProject !== null ? "否" : ""
                    }}
                </div>
            </div>
            <div class="approval-item clearfix">
                <div class="key">计佣区域</div>
                <div class="value">
                    {{ applicationDetails.allocationTable.commissionArea }}
                </div>
            </div>

            <div class="approval-item clearfix">
                <div class="key">审批编号</div>
                <div class="value">{{ flowsNo }}</div>
            </div>
            <div class="approval-item clearfix">
                <div class="key">提交时间</div>
                <div class="value">{{ applicationDetails.approvalDateTime }}</div>
            </div>
            <div class="approval-item clearfix">
                <div class="key">所在部门</div>
                <div class="value">{{ applicationDetails.applicantDeptName }}</div>
            </div>
            <div class="approval-item clearfix">
                <div class="key">申请人员</div>
                <div class="value">{{ applicationDetails.applicantName }}</div>
            </div>
            <div class="approval-item clearfix">
                <div class="key">申请人工号</div>
                <div class="value">{{ applicationDetails.applicantNo }}</div>
            </div>
            <div class="approval-item clearfix">
                <div class="key">备注</div>
                <div class="value">{{ applicationDetails.allocationTable.remarks }}</div>
            </div>
        </div>
    </div>
    <!-- 分佣信息 -->
    <div class="approval-body commission-part">
      <div
        class="approval-part"
        v-for="(item, index) in DeptPers"
        :key="item + index"
      >
        <div class="approval-item-title">{{ item.deptName }}</div>
        <div
          class="approval-part"
          v-for="(row, inx) in item.subCommissions"
          :key="row + inx"
        >
          <div class="approval-item clearfix">
            <div class="key">角色</div>
            <div class="value">{{ row.roleName }}</div>
          </div>
          <div class="approval-item clearfix">
            <div class="key">姓名</div>
            <div class="value">{{ row.empName }}</div>
          </div>
          <div class="approval-item clearfix">
            <div class="key">工号</div>
            <div class="value">{{ row.empNo }}</div>
          </div>
          <div v-if="deptRateIsShow" class="approval-item clearfix">
            <div class="key">部门分佣比例</div>
            <div class="value">{{ row.deptRate }}</div>
          </div>
          <div class="approval-item clearfix">
            <div class="key">角色分佣比例</div>
            <div class="value">{{ row.roleRate }}</div>
          </div>
          <div class="approval-item clearfix">
            <div class="key">个人比率</div>
            <div class="value">{{ (row.personRate * 100).toFixed(2) }}%</div>
          </div>
          <div class="approval-item clearfix">
            <div class="key">备注</div>
            <div class="value">{{ row.remark }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="approval-history">
      <div class="approval-item-title">审批流程</div>
      <div class="history-body">
        <div
          class="history-item"
          v-for="(aps, index) in approvalProcess"
          :key="aps + index"
        >
          <div class="approval-point">
            {{
              aps.flowsStatus == 100
                ? "发起申请"
                : aps.flowsStatus == 200
                ? "交管填写分佣信息"
                : aps.flowsStatus == 210
                ? "指定人员填写分佣信息"
                : aps.flowsStatus == 310 || aps.flowsStatus == 90
                ? "分佣人审批"
                : "当前审批人"
            }}

            <!-- <span v-show="aps.flowsStatus == 100">申请人</span>
						<span v-show="aps.flowsStatus == 200">分佣信息填写人</span>
						<span v-show="aps.flowsStatus == 210">分佣信息填写人</span>
						<span v-show="aps.flowsStatus == 310">基础审批</span> -->
            <span class="or-sign" v-show="aps.orSign == true">或签</span>
          </div>
          <div class="approval-content">
            <div
              class="approval-people"
              v-for="(item, inx) in aps.approvals"
              :key="item + inx"
            >
              <span class="head-img">
                <i class="el-icon-user-solid"></i>
                <img
                  :src="
                    item.avatar == true
                      ? '../assets/image/user-avatar.png'
                      : item.avatar
                  "
                  alt=""
                />
              </span>

              <span class="name"
                >{{ item.empName }}
                <span v-if="item.approvalResult == 200" style="color: #4ebafc"
                  >同意</span
                >
                <span v-if="item.approvalResult == 100" style="color: #ff4346"
                  >驳回</span
                >
                <span v-if="item.approvalResult == null" style="color: #3e5c9a"
                  >待审批</span
                >
              </span>
              <span class="time">{{ item.approvalDateTime }}</span>
            </div>
            <!-- <div class="approval-idea">{{aps.description}}</div> -->
          </div>
          <div
            class="approval-icon"
            :class="
              even(aps.approvals) == 100
                ? 'approval-icon-refuse'
                : even(aps.approvals) == 200
                ? 'approval-icon-used'
                : 'approval-icon'
            "
          >
            <!-- approval-icon-used 流程节点通过后使用该样式; approval-icon-refuse 流程节点驳回后使用该样式 -->
            <i class="el-icon-user-solid"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="approval-part">
      <el-input
        v-show="approvalTextarea"
        type="textarea"
        :rows="2"
        placeholder="请输入备注"
        v-model="remark"
      >
      </el-input>
      <div class="approval-opt clearfix">
        <div class="btn">
          <!-- <i class="el-icon-check"></i>同意  false:可用；true禁用 -->
          <el-button
            @click="AgreeA"
            type="primary"
            size="medium"
            :disabled="isDisabled"
            >同 意</el-button
          >
        </div>
        <div class="btn">
          <!-- <i class="el-icon-close"></i>驳回 -->
          <el-button @click="RejectA" size="medium" :disabled="isDisabled"
            >驳 回</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getAllocationTemplatePagers,
  getTemplateDetail,
  getAllocationTableHeaderDto,
  getFlowsTableDetail,
  getEmployeeFill,
  getBasicEmployeeApproval,
  getAvatar,
  getEmployeeSubordinateInfo,
} from "@/api/allocation";
export default {
  data() {
    return {
      remark: "",
      DeptPers: [],
      DeptPersDuplicate: [],
      DeptPer: {
        deptName: "",
        subCommissions: [],
      },
      applicationDetails: {
        applicantDeptFullName: "",
        applicantDeptName: "",
        applicantName: "",
        applicantNo: "",
        applyChangeDate: "",
        allocationTable: {},
      },
      approvalProcess: [],
      flowsNo: null,
      operator: null,
      isDisabled: false,
      monisShow: false,
      loginAvatar: null,
      flowsStat: 100,
      deptRateIsShow: false,
      res: null,
      avatarMap: new Map(),
      approvalTextarea:false
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.logInfo = this.getLoginUserInfo();
    this.status = this.$route.query.status;
    this.operator = this.$route.query.operator;
    //判断是否是IOS系统
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      this.setCookie("logInfo",encodeURI(JSON.stringify(this.logInfo)),7200)
    }
    this.getData();
  },
  mounted() {},
  methods: {
    //方法
    getData: async function () {
      var that = this;
      let empNo = this.logInfo.EmpNo;
      let jobLevel = this.logInfo.JobLevel;
      if (
        empNo == "SC09110035" &&
        empNo == "SC12050030" &&
        empNo == "SC16005075" &&
        empNo == "SC17001763" &&
        empNo == "SC18002633"
      ) {
        this.deptRateIsShow = true;
      }
      getAvatar(empNo).then((res) => {
        this.loginAvatar = res.body;
        this.avatarMap.set(empNo, this.loginAvatar);
      });
      if (jobLevel >= 7) {
        this.monisShow = true;
      }
      var flowsStatu = null;
      await getFlowsTableDetail(this.id).then((response) => {
        let resCopy = JSON.stringify(response);
        this.res = response;
        console.log(response)
      });
      flowsStatu = this.res.body.flowsStatus;
      let isDis = false;
      let ems = [];

      let rows = this.res.body.rows;
      let approvals = this.res.body.approvalInfo.approvals;
      let applicantNo = this.res.body.applicantNo;
      approvals.forEach((approval) => {
        if (approval.approvals[0].empNo == applicantNo) {
          let dateTimea = approval.approvals[0].approvalDateTime;
          let date = dateTimea.split("", 10).join("");
          this.$set(this.applicationDetails, "approvalDateTime", date);
        }
      });
          rows.forEach((row) => {
              if ((row.signed != "SC09110035" && row.signed != "SC12050030" && row.signed != "SC16005075"
                  && row.signed != "SC17001763" &&  row.signed != "SC18002633") || row.time != 1) {
                ems.push(row.empNo);
              }
          });
          debugger
      if (!ems.includes(this.logInfo.EmpNo)) {
        this.Message({
          message: "没有审批权限",
          type: "error",
          duration: 1000,
        });
        this.isDisabled = true;
      }

      if (flowsStatu != 210 && flowsStatu != 310) {
        this.Message({
          message: "没有审批权限",
          type: "error",
          duration: 1000,
        });
        this.isDisabled = true;
      }

      let domainAccount = this.logInfo.EmpNo.toLocaleLowerCase();
      if (
        domainAccount != this.operator.toLocaleLowerCase() &&
        this.isDisabled == false
      ) {
        this.Message({
          message: "没有审批权限",
          type: "error",
          duration: 1000,
        });
              this.isDisabled = true;
          } 
      this.approvalProcess = [];
      let depts = [];
      let agreePer = [];
      let apls = this.res.body.approvalInfo.approvals;
      this.applicationDetails.applicantDeptFullName = this.res.body.applicantDeptFullName;
      this.applicationDetails.applicantDeptName = this.res.body.applicantDeptName;
      this.applicationDetails.applicantName = this.res.body.applicantName;
      this.applicationDetails.applicantNo = this.res.body.applicantNo;
      this.applicationDetails.applyChangeDate = this.res.body.allocationTable.applyChangeDate;
      this.applicationDetails.allocationTable = this.res.body.allocationTable;
      this.flowsNo = this.res.body.flowsNo;
      rows = rows.filter((row) => row.time != 1);

      let rowMap = new Map();
      rows.forEach((row) => {
        if (rowMap.get(row.empNo) == undefined) {
          rowMap.set(row.empNo, row.approvalStatus);
        }
      });
      apls.forEach((apl) => {
        let per = [];
        let appShow = null;
        if (apl.flowsStatus != 310&&apl.flowsStatus != 90) {
          this.approvalProcess.push(apl);
        } else {
          apl.approvals = apl.approvals.filter(
            (appr) => appr.remark != "系统自动通过"
          );
          if (approvals[approvals.length - 1].flowsStatus == 310) {
            if (rowMap.get(this.logInfo.EmpNo) == null) {
              let approval = null;
              apl.approvals.forEach((apps) => {
                if (apps.empNo == this.logInfo.EmpNo) {
                  approval = apps;
                }
              });
              if (approval != null) {
                if (approval.approvalResult == null) {
                  apl.approvals = [approval];
                }
              }
              this.approvalProcess.push(apl);
            } else {
              this.approvalProcess.push(apl);
            }
          } else {
            this.approvalProcess.push(apl);
          }
        }
      });
      rows.forEach((row) => {
        if (!depts.includes(row.deptName)) {
          depts.push(row.deptName);
        }
      });
      depts.forEach((deptName) => {
        rows.forEach((row) => {
          if (row.deptName == deptName) {
            let subCommission = {
              deptName: "",
              roleName: "",
              empName: "",
              empNo: "",
              deptRate: "",
              roleRate: "",
              personRate: "",
              remark: "",
            };
            subCommission.deptName = row.deptName;
            subCommission.roleName = row.roleName;
            subCommission.empName = row.empName;
            subCommission.empNo = row.empNo;
            subCommission.deptRate = row.deptRate;
            subCommission.roleRate = row.roleRate;
            subCommission.personRate = row.personRate;
            subCommission.remark = row.remark;
            this.DeptPer.subCommissions.push(subCommission);
          }
        });
        this.DeptPer.deptName = deptName;
        let DeptPerCopy = JSON.stringify(this.DeptPer);
        this.DeptPersDuplicate.push(JSON.parse(DeptPerCopy));
        this.DeptPer.subCommissions = [];
      });
      let Datas = [];
      let deptp = {
        deptName: "",
        subCommissions: [],
      };
      let empInfo = null;
      await getEmployeeSubordinateInfo(this.id).then((item) => {
        empInfo = item;
      });
      let map = new Map();
      this.DeptPersDuplicate.forEach((deptPer) => {
        deptPer.subCommissions.forEach((item) => {
          let empNos = empInfo.body;
          if (empNos != null) {
            if (
              item.empNo == this.logInfo.EmpNo ||
              empNos.includes(item.empNo)
            ) {
              if (map.get(deptPer.deptName) == undefined) {
                map.set(deptPer.deptName, "");
              }
              deptp.deptName = "分佣信息";
              deptp.subCommissions.push(item);
            }
          } else {
            if (item.empNo == this.logInfo.EmpNo) {
              if (map.get(deptPer.deptName) == undefined) {
                map.set(deptPer.deptName, "");
              }
              deptp.deptName = "分佣信息";
              deptp.subCommissions.push(item);
            }
          }
        });
      });

      Datas.push(deptp);
      this.DeptPers = Datas;
      let isAfterApproval = true;
      await getFlowsTableDetail(this.id).then((res) => {
        let rows = res.body.rows;
        let emps = [];
        rows.forEach((row) => {
          emps.push((row.empNo||"").toUpperCase());
          if (row.empNo == this.logInfo.EmpNo) {
            if (row.approvalStatus == null) {
              isAfterApproval = false;
            } else {
              if (row.approvalStatus == 100) {
                this.flowsStat = 500;
              } else {
                this.flowsStat = row.approvalStatus;
              }
            }
          }
        });
        if (!emps.includes((this.logInfo.EmpNo||"").toUpperCase())) {
          isAfterApproval = false;
        }
      });
      let isNUll = false  ;

      var isNullApls = this.res.body.approvalInfo.approvals
      
      if(isNullApls[isNullApls.length - 1].flowsStatus == 210){
          isNUll = true;
        }
      if (isNUll) {
        let ap = {
          approvals: [
            {
              avatar: this.loginAvatar,
              approvalResult: rowMap.get(this.logInfo.EmpNo),
              empName: this.logInfo.EmpName,
              empNo: this.logInfo.EmpNo,
            },
          ],
          flowsStatu: 0,
        };
        this.approvalProcess.push(ap);
      }
      if (isAfterApproval) {
        this.Message({
          message: "已审批，请勿重复操作！",
          type: "error",
          duration: 1000,
        });
        this.isDisabled = true;
        
      }
      for (let i = 0; i < that.approvalProcess.length; i++) {
        for (let j = 0; j < that.approvalProcess[i].approvals.length; j++) {
          await getAvatar(that.approvalProcess[i].approvals[j].empNo).then((res) => {
              that.$set(that.approvalProcess[i].approvals[j],'avatar',res.body)
            });
        }
      }
    },
    setCookie(key, value, t) {
      var oDate = new Date();
      oDate.setDate(oDate.getDate() + t);
      document.cookie = key + "=" + value + "; expires=" + oDate.toDateString();
    },
    parseArrayToStringForFloat(val){
      val = this.reserveTwo(val);
      if (val!=null){
        if (val.length === 2){
          return `${val[0] * 100}%-${val[1] * 100}%`
        }
        return `${val[0] * 100}%`
      }
      return null;
    },
    reserveTwo(val){
      if (val != null){
        for (let i = 0; i < val.length; i++) {
          val[i] = val[i].toFixed(2)
        }
        return val;
      }
      return null;
    },
    AgreeA: async function () {
      let isAfterApproval = true;
      let that = this;
      getFlowsTableDetail(that.id).then((res) => {
        let rows = res.body.rows;
        rows.forEach((row) => {
          if ((row.empNo||"").toUpperCase() == (that.logInfo.EmpNo||"").toUpperCase()) {
            if (row.approvalStatus == null) {
              isAfterApproval = false;
            }
          }
        });
        if (isAfterApproval) {
          that.Message({
            message: "已审批，请勿重复操作！",
            type: "error",
            duration: 1000,
          });
          that.isDisabled = true;
        }else{
          that.Agree();
        }
      });
    },
    RejectA: async function () {
      let isAfterApproval = true;
      let that = this;
      getFlowsTableDetail(that.id).then((res) => {
        let rows = res.body.rows;
        rows.forEach((row) => {
          if ((row.empNo||"").toUpperCase() == (that.logInfo.EmpNo||"").toUpperCase()) {
            if (row.approvalStatus == null) {
              isAfterApproval = false;
            }
          }
        });
        if (isAfterApproval) {
          that.Message({
            message: "已审批，请勿重复操作！",
            type: "error",
            duration: 1000,
          });
          that.isDisabled = true;
        }else{
          that.Reject();
        }
      });
    },
    Reject: async function () {
      this.isDisabled = true;
      let approval = {
        IsAgree: false,
        Remark: this.remark,
      };
      this.flowsStat = 500;
      await getBasicEmployeeApproval(this.id, approval).then((res) => {
        if (res.body != null) {
          let apls = res.body.item3.approvalInfo.approvals;
          let appShow = null;
          this.approvalProcess = [];
          apls.forEach((apl) => {
            if (apl.flowsStatus != 310) {
              this.approvalProcess.push(apl);
            } else {
              apl.approvals = apl.approvals.filter(
              (appr) => appr.remark != "系统自动通过"
            );
              apl.approvals.forEach((app) => {
                if (app.empNo == this.logInfo.EmpNo) {
                  appShow = app;
                }
              });
              apl.approvals = [appShow];
              this.approvalProcess.push(apl);
            }
          });
          this.isDisabled = true;
          this.Message({
            message: "操作成功",
            type: "success",
            duration: 3 * 1000,
          });
          setTimeout(() => {
            this.$router.push("/index");
          }, 3000);
        } else {
          this.Message({
            message: "没有权限",
            type: "error",
            duration: 1000,
          });
        }
      }).catch(e => {
        this.isDisabled = true;
      });
    },
    Agree: async function () {
      this.isDisabled = true;
      let approval = {
        IsAgree: true,
        Remark: this.remark,
      };
      this.flowsStat = 200;
      await getBasicEmployeeApproval(this.id, approval).then((res) => {
        if (res.body != null) {
          let apls = res.body.item3.approvalInfo.approvals;
          let appShow = null;
          this.approvalProcess = [];
          apls.forEach((apl) => {
            if (apl.flowsStatus != 310) {
              apl.approvals = apl.approvals.filter(
              (appr) => appr.remark != "系统自动通过"
            );
              apl.approvals.forEach((appr) => {
                getAvatar(appr.empNo).then((ava) => {
                  this.$set(appr, "avatar", ava.body);
                });
              });
              this.approvalProcess.push(apl);
            } else {
              
              apl.approvals.forEach((app) => {
                if (app.empNo == this.logInfo.EmpNo) {
                  appShow = app;
                }
              });

              if (appShow != null) {
                if (apl.approvals != null) {
                  apl.approvals = [appShow];
                  apl.approvals.forEach((appr) => {
                    getAvatar(appr.empNo).then((ava) => {
                      this.$set(appr, "avatar", ava.body);
                    });
                  });
                }

                this.approvalProcess.push(apl);
              }
            }
          });
          this.isDisabled = true;
          this.Message({
            message: "操作成功",
            type: "success",
            duration: 3 * 1000,
          });
          setTimeout(() => {
            this.$router.push("/index");
          }, 3000);
        } else {
          this.Message({
            message: "没有权限",
            type: "error",
            duration: 1000,
          });
        }
      }).catch(e => {
        this.isDisabled = false;
      });
    },
    even(datas) {
      if (datas.length > 1) {
        let judges = [];
        datas.forEach((data) => {
          judges.push(data.approvalResult);
        });
        if (judges.includes(100)) {
          return 100;
        } else {
          return 200;
        }
      } else {
        return datas[0].approvalResult;
      }
    },
    done(num,count){
      var newNum=parseInt(num*Math.pow(10,count))/Math.pow(10,count);
      return newNum;
    }
  },
  watch: {},
};
</script>

<style>
</style>
